import React, { FC, useEffect, useState } from 'react';
import clsx from 'clsx';

import { Input } from 'components/common/Form';
import { Eye, EyeCrossed } from 'components/common/Icon';

import type { LoginFormValidationsFields } from '../types';
import type { EventListenerManager } from './useEventListenerManager';

import style from './LoginForm.scss';

type LoginPasswordProps = {
  passwordField: LoginFormValidationsFields['password'];
  onSubmitListenerManager: EventListenerManager<(isError: boolean) => void>;
};

const PASSWORD = 'password' as const;
const TEXT = 'text' as const;
type PasswordType = typeof PASSWORD | typeof TEXT;

export const LoginPassword: FC<LoginPasswordProps> = ({
  passwordField,
  onSubmitListenerManager,
}) => {
  const [passwordType, setPasswordType] = useState<PasswordType>(PASSWORD);
  const handlePasswordVisibilityToggle = () => {
    setPasswordType(passwordType === PASSWORD ? TEXT : PASSWORD);
  };

  useEffect(() => {
    const listener = onSubmitListenerManager.listen((isError) => {
      if (isError) {
        setPasswordType(PASSWORD);
      }
    });
    return () => onSubmitListenerManager.remove(listener);
  }, [onSubmitListenerManager]);

  return (
    <div className={clsx(style.field, style.passwordField)}>
      <Input {...passwordField} type={passwordType}>
        <button
          type="button"
          data-test="login-form-password-visibility-toggle"
          className={style.passwordVisibilityToggleButton}
          onClick={handlePasswordVisibilityToggle}
        >
          {passwordType === PASSWORD ? <Eye /> : <EyeCrossed />}
        </button>
      </Input>
    </div>
  );
};
